var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "05 Feedback indicators/Spinner");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "GL01---Error-Messages",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "error-module-desk-pre-error",
  transform: "translate(-436.000000, -579.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(0.000000, -226.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(432.000000, 801.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-FeedbackIndicator",
  transform: "translate(4.000000, 4.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#EBE6F6",
  cx: 8,
  cy: 8,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#CDC3E8",
  cx: 4,
  cy: 20,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#AC9BD9",
  cx: 8,
  cy: 32,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#8B72CA",
  cx: 20,
  cy: 36,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#5738B4",
  cx: 32,
  cy: 32,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#3F2CA5",
  cx: 36,
  cy: 20,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#32269D",
  cx: 32,
  cy: 8,
  r: 4
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#171C8F",
  cx: 20,
  cy: 4,
  r: 4
}))))));

var SvgSpinner = function SvgSpinner(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpinner, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spinner.8da8be6d.svg";
export { ForwardRef as ReactComponent };